import React from 'react';
import { Button } from './Button';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  sessionId: string;
  facilitatorName?: string;
}

export function DeleteConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  sessionId,
  facilitatorName,
}: DeleteConfirmationModalProps) {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <h3 className="text-xl font-semibold text-gray-900 mb-4">
          Delete Session?
        </h3>
        <p className="text-gray-600 mb-2">
          Are you sure you want to delete this session?
        </p>
        <div className="mb-4 space-y-1">
          <p className="text-sm text-gray-500">
            <strong>Session ID:</strong> {sessionId}
          </p>
          {facilitatorName && (
            <p className="text-sm text-gray-500">
              <strong>Facilitator:</strong> {facilitatorName}
            </p>
          )}
        </div>
        <p className="text-sm text-red-600 mb-6">
          This action cannot be undone. All participants will be disconnected.
        </p>
        <div className="flex gap-3 justify-end">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirm}>
            Delete Session
          </Button>
        </div>
      </div>
    </div>
  );
}

